import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import type { ReactElement } from 'react'
import {
  Button,
  type ButtonVariation
} from '~/components/Global/Interactions/Button'
import {
  bulkProcessActionDescriptor,
  bulkProcessActionOrder
} from '../bulkProcessActions'
import type { BulkProcessAction } from '../mutations/bulkProcessApplications'

type BulkProcessActionButtonsProps = {
  variation: ButtonVariation
  onSelect: (action: BulkProcessAction) => void
}

export const BulkProcessActionButtons = ({
  variation,
  onSelect
}: BulkProcessActionButtonsProps): ReactElement => (
  <>
    {bulkProcessActionOrder.map((action) => {
      const { label, icon } = bulkProcessActionDescriptor(action)
      return (
        <Button
          key={action}
          variation={variation}
          buttonSize="small"
          onClick={() => onSelect(action)}
        >
          <FontAwesomeIcon icon={icon} />
          {label}
        </Button>
      )
    })}
  </>
)
